export const ONE_DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24;
